import React, { useRef, useState, useEffect } from 'react';
import useSWR from 'swr';
//@ts-ignore
import ChatView from '~/_base/components/insightsChatView';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import ApeHostNotifications from '../../_base/functions/apeHostNotifications';
import api from '~/_base/constants/api';
import logger from '~/_base/logger';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

export interface SelectedProject {
  id: number;
  active: boolean;
  job_number: string;
  name: string;
  selected: boolean;
}

interface SessionContext {
  project?: number;
  projectName?: string;
  projectJobNumber?: string;
  user?: number;
}

interface Props {
  selectedProject?: SelectedProject | null;
  position: number;
}

export default function SiteAssistant(props: Props) {
  const { current: iosSafari } = useRef(checkIosSafari());
  const { data: currentContext } = useSWR(
    api.currentContext.address,
    api.currentContext.request
  );
  const { t } = useTranslation();
  const theme = useTheme();

  function checkIosSafari() {
    if (typeof window != 'undefined') {
      let ua = window.navigator.userAgent;
      let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      let webkit = !!ua.match(/WebKit/i);
      return iOS && webkit && !ua.match(/CriOS/i);
    }
  }

  const [open, setOpen] = useState(false);

  useEffect(() => {
    function notifier(event: any) {
      if (event.type === 'NoOperationNavigation') {
        if ((event.uri || '').indexOf('site_assistant') !== -1) {
          setOpen(true);
        }
      }
    }
    ApeHostNotifications.pushNotifier(notifier);
    return () => {
      ApeHostNotifications.removeNotifier(notifier);
    };
  }, []);

  useEffect(() => {
    if (open === true) {
      setTimeout(() => {
        const element = document.getElementById('apeInsightsInput');
        if (element) {
          element.focus();
        }
      }, 100);
    }
  }, [open]);

  const { position } = props;

  if (currentContext?.current_user == null) {
    return <div />;
  }

  let context: SessionContext = {};
  if (props.selectedProject) {
    context.project = props.selectedProject.id;
    context.projectName = props.selectedProject.name;
    context.projectJobNumber = props.selectedProject.job_number;
  }
  if (currentContext?.current_user) {
    context.user = currentContext.current_user.id;
  }

  return (
    <div>
      <Button
        id="openInsights"
        variant="contained"
        color="primary"
        size="large"
        className={`insights_position_${position}`}
        onClick={() => {
          logger.info('Site assistant drawer button clicked (opened)');
          setOpen(true);
        }}
      >
        {t('Site Assistant')}
      </Button>
      <Drawer
        classes={{
          paper: `insightsDrawer`,
        }}
        className="ape-insights-drawer"
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          zIndex: theme.zIndex.drawer + 2,
        }}
      >
        <div id="apeSiteAssistantWrapper">
          <div
            className="pseudoOpenInnsightsButtonContainer"
            onClick={() => setOpen(false)}
          >
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={`pseudoBtn insights_position_${position}`}
              >
                {t('Site Assistant')}
              </Button>
          </div>
          <div id="chatWrapper" className={iosSafari ? 'iosSafari' : ''}>
            <ChatView sessionContext={context} />
          </div>
        </div>
      </Drawer>
    </div>
  );
}
